export default __webpack_public_path__ + "static/media/amex.10e7f549.svg";